import {
  FilterOutlined,
  PlusOutlined,
  UndoOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import { Tooltip, Button, Badge } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import GetUsersApi from "../../api/users/GetUsersApi";
import GetUsersFilterApi from "../../api/users/GetUsersFilter";
import { SetupStatusApi } from "../../api/SetupStatusApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddUserModal from "../../components/modal/add/AddUserModal";
import UsersFilterModal from "../../components/modal/filters/UsersFilterModal";
import PageLoader from "../../components/sub/PageLoader";
import UsersTable from "../../components/tables/UsersTable";
import UsersTree from "../../components/tree/UsersTree";
import { useSelector } from "react-redux";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function Users() {
  const [canStart, setCanStart] = useState(false);
  const [data, setData] = useState();
  const [tree, setTree] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const [tableLoading, setTableLoading] = useState(false);
  const [page, setPage] = useState(1);
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  useEffect(() => {
    getSetupProgress();
    setFilterBy({
      employeeId: "",
      username: "",
      name: "",
      designation: "",
      userRoleId: "",
      status: "",
      unit: "",
    });
  }, []);

  async function getSetupProgress() {
    const apiResponse = await SetupStatusApi();
    if (apiResponse.success) {
      if (apiResponse.data?.positions) {
        if (apiResponse.data?.users) {
          getAllUsers(1);
        } else {
          getFirstUser(1);
        }
      }
      setCanStart(true);
    }
  }

  async function getFirstUser(num) {
    const apiResponse = await GetUsersApi(num, LIMIT_PER_PAGE);
    if (apiResponse.success) {
      setData(apiResponse.data);
    }
  }

  async function getAllUsers(num) {
    setTableLoading(true);
    const apiResponse = await GetUsersApi(num, LIMIT_PER_PAGE);
    if (apiResponse.success) {
      setData(apiResponse.data);
      setTableLoading(false);
      /*For the first user add */

      setPage(num);
    }
  }

  async function getFilteredUsers(values, num) {
    setTableLoading(true);
    const apiResponse = await GetUsersFilterApi(
      values.username || "",
      values.employeeId || "",
      values.name || "",
      values.designation || "",
      values.userRoleId || "",
      values.status || "",
      values.unit || "",
      num,
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      setFilterStatus(true);
      setData(apiResponse.data);
      setTableLoading(false);
      setFilterBy({
        username: values.username || "",
        employeeId: values.employeeId || "",
        name: values.name || "",
        designation: values.designation || "",
        userRoleId: values.userRoleId || "",
        status: values.status || "",
        unit: values.unit || "",
      });
      setPage(num);
    }
  }

  function changeTablePage(num) {
    if (filterStatus) {
      getFilteredUsers(filterBy, num);
    } else {
      getAllUsers(num);
    }
  }

  function resetFilter() {
    getAllUsers(1);
    setFilterStatus(false);
    setFilterBy();
  }

  const right = (
    <>
      {!tree && (
        <>
          <Tooltip title={"Reset"}>
            <Button
              disabled={!filterStatus}
              onClick={() => resetFilter()}
              className="mr-3"
            >
              <UndoOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Filter"}>
            <Badge
              count={
                filterStatus ? (
                  <CheckCircleFilled style={{ color: "#f5222d" }} />
                ) : (
                  0
                )
              }
            >
              <Button onClick={() => setFilterModal(true)}>
                <FilterOutlined />
              </Button>
            </Badge>
          </Tooltip>
        </>
      )}
      {permissionAbility(userLevel, "users", "add") && (
        <Tooltip placement="left" title={"Add User"}>
          <Button
            className="ml-3"
            onClick={() => setAddModal(true)}
            shape="circle"
            type="primary"
            icon={<PlusOutlined />}
          ></Button>
        </Tooltip>
      )}
    </>
  );

  const left = (
    <>
      <div className="pri-font text-lg">
        {"Users (" + (data?.totalCount || 0) + ")"}
      </div>
      {/* {canShow &&
        (tree ? (
          <Tooltip title={"Table view"}>
            <Button onClick={() => setTree(false)} className="ml-3">
              <TableOutlined />
            </Button>
          </Tooltip>
        ) : (
          <Tooltip title={"Tree view"}>
            <Button onClick={() => setTree(true)} className="ml-3">
              <ApartmentOutlined />
            </Button>
          </Tooltip>
        ))} */}
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            tree ? (
              <UsersTree />
            ) : (
              <UsersTable
                changePage={(num) => changeTablePage(num)}
                data={data}
                loading={tableLoading}
                page={page}
              />
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <AddUserModal
        visible={addModal}
        handleCancel={() => setAddModal(false)}
        handleOk={() => getAllUsers(1)}
      />
      <UsersFilterModal
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => getFilteredUsers(values, 1)}
        filterBy={filterBy}
      />
    </>
  );
}

export default Users;
